import React from "react";
import TopicsInput from "../topics/TopicsInput";

export default function TodoInput({
  todoText,
  setTodoText,
  topicId,
  setTopicId,
  clientView
}) {
  return (
    <div>
      <div className="row">
        <div className="col-md-10">
          <input
            type="text"
            className="form-control"
            placeholder="Describe Todo here..."
            onChange={(e) => setTodoText(e.target.value)}
            value={todoText}
            style={{ width: "100%", marginBottom: "6px" }}
          />
          <TopicsInput
            multiple={false}
            value={topicId}
            onChange={(option) => {
              setTopicId(option ? option.value : null);
            }}
            clientView={clientView}
            defaultStyle
          />
        </div>
        <div className="col-md-2">
          <button
            type="submit"
            className="btn btn-warning btn-block"
            style={{ marginLeft: "4px", marginBottom: 0 }}
          >
            {I18n.t("add_todo")}
          </button>
        </div>
      </div>
      {clientView && (
        <p className="info" style={{ marginTop: 10 }}>
          The laboratory staff cannot see the todos you add here.
        </p>
      )}
      {!clientView && (
        <p className="info" style={{ marginTop: 10 }}>
          These todos are only visible to laboratory staff.
        </p>
      )}
    </div>
  );
}
